import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: 'テナント',

  // model
  tenantModel: [],

  // 検索
  filters: {
    searchName: null,
    searchStatus: '',
  }
}

const getters = {
  get: state => state
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {tenantParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['tenant'],
        ['v1TenantListGet'],
        [tenantParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setTenantModel', res[0].data.tenants)
            console.log('tenantModel', state.tenantModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  /**
   * テナント一覧を読出し
   */
  loadTenantList ({commit}, {tenantParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['tenant'],
        ['v1TenantListGet'],
        [tenantParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setTenantModel', res[0].data.tenants)
            console.log('tenantModel', state.tenantModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  }
}

const mutations = {
  // model
  setTenantModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'tenantModel', data)
  },

  setInputFilter (state, {key, value}) {
    Vue.set(state.filters, key, value)
  },

  resetState (state) {
    Vue.set(state, 'tenantModel', [])

    state.filters.searchName = null
    state.filters.searchStatus = ''
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
